export const name = '$gzBrowser';
/**
 * @ngdoc service
 * @name gazelle.components.browser.service:$gzBrowser
 *
 * @description Gazelle browser service for checking browser properties and capabilities.
 * This is sadly necessary because some libraries and features simply act different or don't
 * work on particular platforms.
 * This module may also be extended with a show/hide attribute directive to simplify expressions like
 * `ng-if='!$gzBrowser.isMobile()'`.
 *
 * @example
 * ```js
 *   $gzBrowser.isMobile();
 * ```
 */
export default function $gzBrowser($window) {
  'ngInject';

  const USER_AGENT_MOBILE_REGEX = /android|iemobile|ipad|iphone|ipod|phone|windows phone/i;

  let service = {
    isMobile: isMobile,
    isDesktop: isDesktop,
  };
  return service;

  //////////////

  /**
   * @ngdoc function
   * @name isMobile
   * @methodOf gazelle.components.browser.service:$gzBrowser
   * @description Checks if the browser is on a mobile device (phone or tablet)
   * @returns {boolean} true if the browser platform is a mobile device (phone or tablet), false otherwise
   */
  function isMobile() {
    let mobile = USER_AGENT_MOBILE_REGEX.test($window.navigator.userAgent);
    return mobile;
  }

  /**
   * @ngdoc function
   * @name isDesktop
   * @methodOf gazelle.components.browser.service:$gzBrowser
   * @description Checks if the browser is on a desktop platform (that is, not a mobile platform)
   * @returns {boolean} true if the browser is on a desktop platform (that is, not a mobile platform), false otherwise
   */
  function isDesktop() {
    return !isMobile();
  }
}
